import { useMemo } from 'react';
import { useAppSelector } from '../../app/hooks';
import { RootState } from '../../app/store';

const useSelectedCartItems = () => {
  const cart = useAppSelector((state: RootState) => state.cart);
  const selectedItem =
    useAppSelector((state) => state.dialog.selectedItem) ||
    Object.values(cart.cartItems)[Object.values(cart.cartItems).length - 1];

  const selectedCartItem = useMemo(() => {
    if (!selectedItem) return undefined;

    return cart.cartItems?.[selectedItem?.cartItemId];
  }, [selectedItem, cart.cartItems]);

  const dialogSelectedItemCartId = useAppSelector(
    (state) => state.dialog.selectedItemCartId
  );

  const selectedItemCartId = (() => {
    if (
      typeof dialogSelectedItemCartId === 'number' &&
      dialogSelectedItemCartId
    ) {
      return dialogSelectedItemCartId;
    }

    if (selectedItem && typeof selectedItem.cartItemId === 'number') {
      return selectedItem.cartItemId;
    }

    // Fallback
    return 0;
  })();

  return {
    cart,
    selectedItem,
    selectedCartItem,
    selectedItemCartId,
  };
};

export default useSelectedCartItems;
